import { trackReportEvent } from './report-tracking'

import type { HeapProperties } from '@app/adapters/heap'

// Named: Heap creates an event on first sight, so a typo starts a fifth one.
type PeriodSetEvent = 'Created' | 'Updated' | 'Deleted' | 'Switched'

// Where the user did it. The same four things can be done to the same sets from
// Report Settings, so the surface is a property rather than part of the name:
// the lifecycle stays countable whoever raises it.
export type PeriodSetSurface = 'drawer' | 'picker'

// What the report is being read with, as ReportsHelper#report_period_set_options
// labels it: the report's own columns, a set that came with the report, or one a
// user saved. Named for the tracking, which is the only thing that asks.
export type PeriodSetKind = 'default' | 'built_in' | 'custom'

export function trackPeriodSet(
  action: PeriodSetEvent,
  surface: PeriodSetSurface,
  properties: HeapProperties = {}
): void {
  trackReportEvent(`Period Set: ${action}`, { surface, ...properties })
}
